// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  elementProps: PropTypes.object
};

MarkdownComponent.defaultProps = {
  elementProps: {}
};

MarkdownComponent['title'] = 'macOS';

MarkdownComponent['emoji'] = ':finder:';

function MarkdownComponent(props) {
  const { className, style, elementProps } = props;

  return (
    <div className={className} style={style}>
      <p {...elementProps['p']}>If you have <a href="http://brew.sh/" {...elementProps['a']}>Homebrew</a> installed you can use our <a href="https://github.com/buildkite/homebrew-buildkite" {...elementProps['a']}>Buildkite formula repository</a> to install the agent:</p>
      <pre {...elementProps['pre']}><code className="language-bash" {...elementProps['code']}>brew tap buildkite/buildkite<br {...elementProps['br']} />brew install --token=<span className="hljs-string" {...elementProps['span']}>'{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }'</span> buildkite-agent<br {...elementProps['br']} /></code></pre>
      <p {...elementProps['p']}>If you don't use Homebrew you should follow the <a href="/docs/agent/linux" {...elementProps['a']}>Linux</a> install instructions.</p>
      <p className="rounded bg-silver p2" {...elementProps['p']}>See the <a href="/docs/agent/osx" {...elementProps['a']}>macOS agent docs</a> for more details.</p>
    </div>
  );
};

export default MarkdownComponent;
